<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-toast></p-toast>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Actualizar Artículo"
  [style]="{ width: '750px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="mt-3 mb-2">
          <p-fieldset
            legend="Datos"
            [toggleable]="true"
            class="mt-3 mb-2 md:mt-0"
          >
            <div class="p-fluid p-formgrid grid">
              <div class="field col-12 md:col-6">
                <label class="label-required">Código</label>
                <input pInputText formControlName="code" type="text" />
                <div
                  *ngIf="
                    fg.get('code').invalid &&
                    (fg.get('code').dirty || fg.get('code').touched)
                  "
                  class="p-invalid"
                >
                  <div *ngIf="fg.get('code').errors?.required">
                    <small class="p-error">No puede quedar vacío.</small>
                  </div>
                  <div *ngIf="fg.get('code').errors?.min">
                    <small class="p-error">Debe ser como minimo 1.</small>
                  </div>
                </div>
              </div>
              <div class="field col-12 md:col-6">
                <label class="label-required">Nombre</label>
                <input pInputText formControlName="name" type="text" />
                <div
                  *ngIf="
                    fg.get('name').invalid &&
                    (fg.get('name').dirty || fg.get('name').touched)
                  "
                  class="p-invalid"
                >
                  <div *ngIf="fg.get('name').errors?.required">
                    <small class="p-error">No puede quedar vacío.</small>
                  </div>
                  <div *ngIf="fg.get('name').errors?.minlength">
                    <small class="p-error"
                      >Debe tener una longitud mínima de 5.</small
                    >
                  </div>
                  <div *ngIf="fg.get('name').errors?.maxlength">
                    <small class="p-error"
                      >Debe tener una longitud máximma de 250.</small
                    >
                  </div>
                </div>
              </div>
              <div class="field col-12 md:col-6">
                <label>Codigo de barras</label>
                <input pInputText formControlName="barCode" type="text" />
                <div
                  *ngIf="
                    fg.get('barCode').invalid &&
                    (fg.get('barCode').dirty || fg.get('barCode').touched)
                  "
                  class="p-invalid"
                >
                  <div *ngIf="fg.get('barCode').errors?.required">
                    <small class="p-error">No puede quedar vacío.</small>
                  </div>
                  <div *ngIf="fg.get('barCode').errors?.minlength">
                    <small class="p-error"
                      >Debe tener una longitud mínima de 5.</small
                    >
                  </div>
                  <div *ngIf="fg.get('barCode').errors?.maxlength">
                    <small class="p-error"
                      >Debe tener una longitud máximma de 32.</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </p-fieldset>
        </div>
      </form>
      <div class="card">
        <p-fieldset legend="Formato de Venta" [toggleable]="true">
          <div class="p-fluid p-formgrid">
            <p-table
              [value]="hierarchyFormats"
              dataKey="id"
              editMode="row"
              responsiveLayout="scroll"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Nombre</th>
                  <th>Sub Formato</th>
                  <th>Cantidad S.F</th>
                  <th>FV</th>
                  <th>FMV</th>
                  <th>FC</th>
                  <th style="width: 8rem"></th>
                </tr>
              </ng-template>
              <ng-template
                pTemplate="body"
                let-formato
                let-editing="editing"
                let-ri="rowIndex"
              >
                <tr [pEditableRow]="formato">
                  <td>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input
                          pInputText
                          type="text"
                          [disabled]="disabled"
                          [(ngModel)]="formato.nombre"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ formato.nombre }}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input
                          pInputText
                          type="text"
                          [disabled]="formato.isFormatSaleMin"
                          [(ngModel)]="formato.subFormat"
                        />
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ formato.subFormat }}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-inputNumber
                          inputId="integeronly"
                          [disabled]="formato.isFormatSaleMin"
                          [(ngModel)]="formato.quantitySubFormat"
                          [min]="1"
                        >
                          >
                        </p-inputNumber>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ formato.quantitySubFormat }}
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-toggleButton
                          [(ngModel)]="formato.isFormatSale"
                          onIcon="pi pi-check"
                          offIcon="pi pi-times"
                        ></p-toggleButton>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <i
                          [ngClass]="
                            formato.isFormatSale === true
                              ? 'pi pi-check'
                              : 'pi pi-times'
                          "
                          style="font-size: 2rem"
                        ></i>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-toggleButton
                          [(ngModel)]="formato.isFormatSaleMin"
                          (click)="cambiarCheck(ri)"
                          onIcon="pi pi-check"
                          offIcon="pi pi-times"
                        ></p-toggleButton>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <i
                          [ngClass]="
                            formato.isFormatSaleMin === true
                              ? 'pi pi-check'
                              : 'pi pi-times'
                          "
                          style="font-size: 2rem"
                        ></i>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <td>
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <p-toggleButton
                          [(ngModel)]="formato.isFormatPurchase"
                          onIcon="pi pi-check"
                          offIcon="pi pi-times"
                        ></p-toggleButton>
                      </ng-template>
                      <ng-template pTemplate="output">
                        <i
                          [ngClass]="
                            formato.isFormatPurchase === true
                              ? 'pi pi-check'
                              : 'pi pi-times'
                          "
                          style="font-size: 2rem"
                        ></i>
                      </ng-template>
                    </p-cellEditor>
                  </td>

                  <td style="text-align: center">
                    <button
                      *ngIf="!editing && activeEdit"
                      pButton
                      pRipple
                      type="button"
                      pInitEditableRow
                      icon="pi pi-pencil"
                      (click)="onHierarchyRowEdit(formato)"
                      class="p-button-rounded p-button-text"
                    ></button>
                    <button
                      *ngIf="editing && activeEdit"
                      pButton
                      pRipple
                      type="button"
                      pSaveEditableRow
                      icon="pi pi-check"
                      (click)="onHierarchyRowEditSave(formato)"
                      class="p-button-rounded p-button-text p-button-success mr-2"
                    ></button>
                    <button
                      *ngIf="editing && activeEdit"
                      pButton
                      pRipple
                      type="button"
                      pCancelEditableRow
                      icon="pi pi-times"
                      (click)="onHierarchyRowEditCancel(formato, ri)"
                      class="p-button-rounded p-button-text p-button-danger"
                    ></button>
                  </td>
                  <td style="text-align: center">
                    <button
                      *ngIf="
                        ri == hierarchyFormatLength &&
                        !hierarchyFormats[ri].isFormatSaleMin &&
                        activeEdit
                      "
                      (click)="hierarchyAddRow(ri)"
                      pButton
                      type="button"
                      class="p-button-success"
                      icon="pi pi-plus-circle"
                    ></button>
                  </td>
                  <td style="text-align: center">
                    <button
                      *ngIf="
                        ri == hierarchyFormatLength && ri > 0 && activeEdit
                      "
                      (click)="hierarchyDeleteRow()"
                      pButton
                      type="button"
                      class="p-button-danger"
                      icon="pi pi-minus-circle"
                    ></button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-fieldset>
      </div>

      <div class="p-fluid p-formgrid grid mt-3 mb-2">
        <div class="field col-12 md:col-4">
          <button
            *ngIf="enabledReload"
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            (click)="reload()"
            class="p-button-text"
            label="Editar Formato"
            pTooltip="Editar Formato de Venta"
            tooltipPosition="top"
          ></button>
        </div>
        <div class="field col-12 md:col-4">
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-refresh"
            (click)="clean()"
            class="p-button-text"
            label="Limpiar Formatos"
            pTooltip="Limpiar Formato de Venta"
            tooltipPosition="top"
          ></button>
        </div>
        <div class="field col-12 md:col-2">
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-times"
            (click)="onClose()"
            class="p-button-text"
            label="No"
            pTooltip="Cancelar Cambios"
            tooltipPosition="top"
          ></button>
        </div>
        <div class="field col-12 md:col-2">
          <button
            type="button"
            (click)="onSubmit()"
            pButton
            [disabled]="!(fg.valid && hasPurchaseFormat && hasMinSaleFormat)"
            pRipple
            icon="pi pi-check"
            class="p-button-text"
            label="Si"
            tooltipPosition="top"
            pTooltip="Guardar Cambios"
          ></button>
        </div>
      </div>
    </div></div
></p-dialog>
